import { ReactElement } from 'react';
import { Popover as AntPopover, PopoverProps } from 'antd';

export const Popover = (props: PopoverProps): ReactElement => <AntPopover {...props} />;
